// extracted by mini-css-extract-plugin
module.exports =  {"container":"_9cadcb71c3--container--FIP7R","tabs":"_9cadcb71c3--tabs--WuOr8"};